export enum InteractionType {
  TICKET = "ticket",
  CONVERSATION = "conversation",
}

export enum InteractionInTrainingStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  IGNORED = "IGNORED",
}

export interface ConversationInTrainingMessage {
  author: string;
  content: string;
  createdAt: number;
  order: number;
}

export interface ConversationInTraining {
  conversationId: string | null;
  conversationInTrainingId: number;
  reason: string;
  order: number;
  createdAt: number;
  status: InteractionInTrainingStatus;
  messages: ConversationInTrainingMessage[];
}

export interface TicketInTrainingComment {
  author: string;
  authorName: string;
}

export interface TicketInTraining {
  ticketId: string;
  displayId: string;
  ticketInTrainingId: number;
  reason?: string;
  status: InteractionInTrainingStatus;
  comments: TicketInTrainingComment[];
  topicId?: number;
  topicName?: string;
  name?: string;
}

export interface CreateInteractionInTrainingRequest {
  interactionId: string;
  interactionType: InteractionType;
  status: InteractionInTrainingStatus;
  reason?: string;
}

export interface ChangeStatusRequest {
  interactionInTrainingId: number;
  interactionType: InteractionType;
  status: InteractionInTrainingStatus;
}

export interface GetInteractionsInTrainingQueryDto {
  topicIds?: number[];
  interactionTypes?: InteractionType[];
  statuses?: InteractionInTrainingStatus[];
  startDate?: string;
  endDate?: string;
  page?: number;
}

export interface InteractionInTrainingItem {
  id: number;
  tenantId: string;
  interactionType: InteractionType;
  status: InteractionInTrainingStatus;
  reason?: string;
  createdAt: Date;
  updatedAt: Date;
  conversationId?: string;
  displayId?: string;
  ticketId?: string;
  firstUserComment?: string;
  submitter?: string;
}

export interface GetInteractionsInTrainingResponse {
  interactions: InteractionInTrainingItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export interface GetInteractionsByTopicResponse {
  topicName: string;
  topicId: number;

  conversations: {
    conversationInTrainingId: number;
    displayId?: string;
    submitter?: string;
    status: InteractionInTrainingStatus;
    reason?: string;
    messages: {
      author: string;
      content: string;
    }[];
  }[];
  tickets: {
    ticketInTrainingId: number;
    displayId: string;
    submitter?: string;
    status: InteractionInTrainingStatus;
    reason?: string;
    comments: {
      author: "agent" | "user";
      comment: string;
    }[];
  }[];
}
